import { createMockCreator } from '@csp/test-common-utils';
import { PracticeV1 } from '../generated/models/PracticeV1';
import { PracticeType } from '../type/PracticeType';

export const practiceV1Mock: PracticeV1 = {
  practiceType: PracticeType.REGULAR,
  practiceCode: 'pc1',
};

export const createPracticeV1Mock = createMockCreator(practiceV1Mock);
